export default __webpack_public_path__ + "static/media/relay.e8d04a1c.webp";